// extracted by mini-css-extract-plugin
export default {"tabTitle":"TabTitle_tabTitle__ihM0O","disabled":"TabTitle_disabled__2mnuP","active":"TabTitle_active__4btTT"};